import React from "react";
import WrapperCard from "../../common/WrapperCard";
// @ts-ignore - SVG import
import XMark from "../../../assets/icons/x-mark.svg";

interface GenericErrorProps {
  bgHook?: {
    setFixedPage?: () => void;
    [key: string]: any;
  };
}

const GenericError: React.FC<GenericErrorProps> = (props) => {
  props.bgHook && props.bgHook.setFixedPage && props.bgHook.setFixedPage();
  return (
    <WrapperCard
      rowClasses="row mt-5 mb-2 mr-0"
      containerClasses="container pt-5 pt-md-3 mb-5 pl-0 pr-0 mt-5 mt-md-0"
    >
      <div className="text-center p-4">
        <img src={XMark} alt="error" className="d-inline-block align-top" />
        <h3 className="text-orange pt-2">Link incorect</h3>
        <p className="mb-4">Te rugăm să verifici linkul accesat.</p>
      </div>
    </WrapperCard>
  );
};

export default GenericError;
